import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';

export type BusinessDeleteData = AnyObject;

export type BusinessDeleteResponse = BusinessDeleteData;

export interface BusinessDelete {
  id: string;
}

export const businessDelete = (payload: BusinessDelete): Action<BusinessDelete> => ({
  type: actions.businessDeleteTrigger.toString(),
  payload,
});

export const businessDeleteClear = (): Action => ({
  type: actions.businessDeleteClear.toString()
});

export const businessDeleteErrorClear = (): Action => ({
  type: actions.businessDeleteErrorReset.toString()
});

export function* businessDeleteRequestSaga({ payload }: Action<BusinessDelete>) {
  yield put({
    type: actions.businessDeleteStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.businessDeleteError.toString(),
      payload: {
        message: 'BusinessDelete: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}businesses/${id}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<BusinessDeleteData, BusinessDeleteResponse>(
    response,
    actions.businessDeleteSuccess.toString(),
    actions.businessDeleteError.toString(),
    false,
    (businessDeleteData) => businessDeleteData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.businessDeleteTrigger.toString(),
    defaultProcessingSaga(
      businessDeleteRequestSaga,
      {
        error: actions.businessDeleteError.toString(),
        locationCancel: actions.businessDeleteClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.businessDeleteSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.businessDeleteClear.toString(),
    // });
  });

  yield takeLatest(actions.businessDeleteError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.businessDeleteErrorReset.toString(),
    });
  });
}
